import React, { useEffect } from "react";

import Actions from "../actions/Actions";
import AddButton from "./add-button/AddButton";
import Tabs from "../tabs/Tabs";
import Design from "../../../../optics/components/drawers/templates/features/cards/designs/Design";
import IntelligenceLoading from "./Intelligence/Loading";
import Prompt from "./Intelligence/Prompt";
import { useCardsStore } from "../../../../stores/use-cards-store";
import { CARDS_TEMPLATES } from "../../../../optics/components/drawers/templates/features/cards/cards-templates";
import { DesignContainer } from "../../../../optics/components/drawers/templates/features/cards/designs/styles";
import { CardsContentContainer, CardsGrid, CardsGridContainer } from "./styles";

const CardsEditor = () => {
  const {
    data,
    setData,
    card,
    setCard,
    hoverCard,
    setHoverCard,
    isPromptLoading,
    cardsTab,
    setCardsTab,
  } = useCardsStore((state) => ({
    data: state.data,
    setData: state.setData,
    card: state.card,
    setCard: state.setCard,
    hoverCard: state.hoverCard,
    setHoverCard: state.setHoverCard,
    isPromptLoading: state.isPromptLoading,
    cardsTab: state.cardsTab,
    setCardsTab: state.setCardsTab,
  }));

  const hasData = !!data?.length;

  useEffect(() => {
    if (hasData && !!data[0]?.tabs?.length) return setCardsTab(data[0].tabs[0]);
  }, [hasData]);

  const { config, tabs } = data[0];

  const cards = config.hasTabs
    ? data.filter((item) => item.card.tabId === cardsTab?.id)
    : data;

  return (
    <CardsContentContainer>
      {isPromptLoading ? (
        <IntelligenceLoading />
      ) : (
        <CardsGridContainer>
          {config.hasTabs && cardsTab && <Tabs tabs={tabs} isEditable />}
          <CardsGrid numberOfColumns={config.columns}>
            {cards.map((data, index) => (
              <DesignContainer
                onClick={() => setCard(data)}
                onMouseEnter={() => setHoverCard(data)}
                onMouseLeave={() => setHoverCard(undefined)}
                isSelected={data.card.id === card?.card.id}
                borderRadius={config.borderRadius}
                style={{ height: "100%", cursor: "pointer" }}
              >
                {hoverCard?.card?.id === data.card.id && (
                  <Actions card={data} />
                )}
                <Design
                  data={data.card}
                  config={data.config}
                  isEditable
                  index={index}
                />
              </DesignContainer>
            ))}
            <AddButton
              hasCards={!!cards.length}
              onClick={() => {
                const existingCard = cards.at(0) || data.at(0);
                const templateCard = CARDS_TEMPLATES.find(
                  ({ config: { design } }) =>
                    design === existingCard.config.design
                );
                const newCard = {
                  ...templateCard,
                  tabs,
                  card: {
                    ...templateCard.card,
                    id: crypto.randomUUID(),
                    tabId: config.hasTabs
                      ? cardsTab?.id
                      : templateCard.card.tabId,
                    colors: existingCard.card.colors,
                  },
                  config: {
                    ...templateCard.config,
                    hasTabs: config.hasTabs,
                    borderRadius: existingCard.config.borderRadius,
                    columns: existingCard.config.columns,
                    layout: existingCard.config.layout,
                  },
                };
                setData(newCard);
              }}
            />
          </CardsGrid>
        </CardsGridContainer>
      )}

      <Prompt isSaving={false} onSave={() => {}} />
    </CardsContentContainer>
  );
};

export default CardsEditor;
